import { render, staticRenderFns } from "./Curso.vue?vue&type=template&id=50855426&"
import script from "./Curso.vue?vue&type=script&lang=js&"
export * from "./Curso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QCard,QForm,QCardSection,QInput,QBtn,QTooltip,QEditor,QSelect,QItem,QItemSection,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QCard,QForm,QCardSection,QInput,QBtn,QTooltip,QEditor,QSelect,QItem,QItemSection,QItemLabel,QIcon})
